import { ComputeFacetsResponse, VertesiaClient } from "@vertesia/client"

import { FacetResponse } from "@models/facets"

import TypeRegistry from "@plugins/session/TypeRegistry"

export function transformFacetStatusResponses(facets: FacetResponse[] | undefined) {
    if (!facets?.length) {
        return []
    }

    const options = facets.map((facet) => {
        const name = facet._id || "Unknown"
        return {
            _id: facet._id,
            name,
            count: facet.count,
        }
    })
    options.sort((a, b) => a.name.localeCompare(b.name))
    return options
}

export function transformFacetTypeResponses(facets: FacetResponse[] | undefined, typeRegistry: TypeRegistry | undefined) {
    if (!facets?.length) {
        return []
    }

    if (!typeRegistry) {
        return facets
    }

    const options = facets.map((facet) => {
        const name = typeRegistry.getTypeName(facet._id) || "Document"
        return {
            _id: name !== "Document" ? facet._id : "Document",
            name,
            count: facet.count,
        }
    })

    options.sort((a, b) => a.name.localeCompare(b.name))
    return options
}

export function transformUser(user: string, client: VertesiaClient, callback: (result: string) => void): void {
    const [type, id] = user ? user.split(":") : []
    if (!id) {
        callback("Unknown User")
        return
    }

    if (type === "user") {
        client.users
            .retrieve(id)
            .then((user) => {
                callback(user?.name || "Unknown User")
            })
            .catch(() => {
                callback("Unknown User")
            })
    } else if (type === "system") {
        callback("System")
    } else if (type === "service_account") {
        callback(`Service Account (${id})`)
    } else {
        callback("Unknown User")
    }
}

export function getOptionCount(filter: string, options: ComputeFacetsResponse): number {
    const filteredOptions: FacetResponse[] = (options as any)[filter] || []
    return Array.isArray(filteredOptions) ? filteredOptions.length : Object.keys(filteredOptions).length
}

export function mergeAndCombineCounts(arr1: { _id: string, count: number }[] = [], arr2: { _id: string, count: number }[] = []) {
    const countMap = new Map<string, number>()

    arr1.forEach(item => {
        countMap.set(item._id, (countMap.get(item._id) || 0) + item.count);
    })

    arr2.forEach(item => {
        countMap.set(item._id, (countMap.get(item._id) || 0) + item.count);
    })

    return Array.from(countMap.entries())
        .map(([_id, count]) => ({ _id, count }))
        .sort((a, b) => b.count - a.count)
}